<template>
  <div id="rwa_index_div" class="rwa_index_div">

    <div class="rwa_index_page_01">
      <Menu/>
    </div>

    <div id="rwa_index_page_02" ref="rwa_index_page_02" class="rwa_index_page_02">

      <!-- 首页内容 -->
      <div class="rwa_index_page_02_01">
        <div class="rwa_index_page_02_011">

          <img class="rwa_index_page_02_011_bj01" src="../../assets/images/Ellipse_bjl.png"/>
          <img class="rwa_index_page_02_011_bj03" src="../../assets/images/Ellipse_bjr.png"/>

          <div class="rwa_index_page_02_0111">
            <div class="rwa_index_page_02_0111_01">
              <div class="index_page_bla_01">
                <div class="index_page_bla_011">
                  <p class="com">{{ lang('index011') }}</p>
                  <p class="com">{{ lang('index012') }}</p>

                  <p class="mob">{{ lang('index01') }}</p>
                </div>
                <div class="index_page_bla_012">
                  {{ lang('index02') }}
                </div>
                <div class="index_page_bla_013">
                  <div class="index_page_bla_0131" @click="toLaunch()">Launch</div>
<!--                  <el-badge value="new" class="item">-->
<!--                    <div class="index_page_bla_0132" @click="toMint(0, null)">Mint</div>-->
<!--                  </el-badge>-->
                  <div class="index_page_bla_0133"  @click="operationGuideVisible = true">
                    <img src="../../assets/images/wenh.png"> 操作引导
                  </div>
                </div>
              </div>
              <div class="index_page_bla_02">
                <img src="../../assets/images/image_sangd.png">
              </div>
            </div>

            <div class="rwa_index_page_02_0111_02">

              <el-tabs v-model="projectsType" @tab-click="handleProjectsClick">
                <el-tab-pane label="全部" name="all"></el-tab-pane>
                <el-tab-pane label="进行中" name="active"></el-tab-pane>
                <el-tab-pane label="已发射" name="launched"></el-tab-pane>
                <el-tab-pane label="已结束" name="ended"></el-tab-pane>
              </el-tabs>

              <div class="rwa_index_page_02_0111_021" v-if="projectsList.length > 0">
                <div class="antique_info_div" v-for="(obj, index) in projectsList" :key="index">
                  <div class="antique_info_div01" @click="toDetails(obj.project_id)">
                    <img :src="imgHost + obj.images_group1[0]"/>

                    <div v-if="getProjectsStatus(obj.start_time, obj.end_time, obj.status) === 0"> {{ toTextDate(obj.start_time, true) }} {{ lang('index04') }}</div>
                    <div v-if="getProjectsStatus(obj.start_time, obj.end_time, obj.status) === 1">{{ lang('index03') }} {{ toTextDate(obj.end_time, false) }} {{ lang('index05') }}</div>
<!--                    <div v-if="getProjectsStatus(obj.start_time, obj.end_time, obj.status) === 2"> {{ toTextDate(obj.end_time, true) }} {{ lang('index05') }}</div>-->
                  </div>

                  <div class="antique_info_div02" @click="toDetails(obj.project_id)">
                    {{ obj.name }}
                  </div>

                  <div class="antique_info_div03" @click="toDetails(obj.project_id)">
                    <div class="antique_info_div031">
                      <div class="antique_info_div0311">
                        <span>{{ lang('index06') }}</span>
                        <div>{{ setDecimal(obj.current_price / 1e18, 6) }} BNB</div>
                      </div>
                      <div class="antique_info_div0312">
                        <span>{{ lang('index07') }}</span>
                        <div>{{ setDecimal(obj.assessed_value / 1e18, 6) }} BNB</div>
                      </div>
                    </div>
<!--                    <div v-if="getProjectsStatus(obj.start_time, obj.end_time, obj.status) === 0" class="antique_info_div032">{{ lang('index09') }}</div>-->
<!--                    <div v-if="getProjectsStatus(obj.start_time, obj.end_time, obj.status) === 1" class="antique_info_div032">{{ lang('index08') }}</div>-->
<!--                    <div v-if="getProjectsStatus(obj.start_time, obj.end_time, obj.status) === 2" class="antique_info_div032 antique_info_div032_end">{{ lang('index10') }}</div>-->
                  </div>

                  <div class="antique_info_div04">
                    <div v-if="getProjectsStatus(obj.start_time, obj.end_time, obj.status) === 0" class="antique_info_div041" @click="toDetails(obj.project_id)">待开始</div>
                    <div v-if="getProjectsStatus(obj.start_time, obj.end_time, obj.status) === 1" class="antique_info_div042" @click="toDetails(obj.project_id)">进行中</div>
                    <div v-if="getProjectsStatus(obj.start_time, obj.end_time, obj.status) === 2" class="antique_info_div043" @click="toDetails(obj.project_id)">已结束</div>
                    <div v-if="getProjectsStatus(obj.start_time, obj.end_time, obj.status) === 3" class="antique_info_div040s">
                      <img class="antique_info_div040s1" src="../../assets/images/kx.png" @click="toKline(obj.token_address)">
                      <div class="antique_info_div040s2" @click="toMint(obj.project_id, obj.token_address)">Mint</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="rwa_index_page_02_0111_021_null" v-if="projectsList.length === 0">
                {{ isProjectsListLoding ? 'Loading...' : 'No Data...' }}
              </div>

              <div class="rwa_index_page_02_0111_022">
                <el-pagination
                    :background="true"
                    @current-change="getProjectsListPage"
                    layout="prev, pager, next"
                    :page-size="limitNum"
                    :total="totalNum">
                </el-pagination>
              </div>
            </div>

            <div class="rwa_index_page_02_0111_03">
              <div class="rwa_index_page_02_0111_031">{{ lang('index11') }}</div>
              <div class="rwa_index_page_02_0111_032">
                <img class="com" src="../../assets/images/List.png">

                <img class="mob" src="../../assets/images/logo_fxhao.png">
                <img class="mob" src="../../assets/images/logo_pancak.png">
                <img class="mob" src="../../assets/images/logo_ave.png">
                <img class="mob" src="../../assets/images/bin.png">
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="rwa_index_page_03">
        <Bottom/>
      </div>
    </div>

    <el-dialog
        :visible.sync="operationGuideVisible">
      <div class="operationGuide_01">
        <div class="operationGuide_011">
          <div class="operationGuide_0111">
            <img src="../../assets/images/wenh.png"/> 操作引导
          </div>
          <img class="operationGuide_0112" src="../../assets/images/guanbi.png" @click="operationGuideVisible = false"/>
        </div>

        <div class="operationGuide_012">
          <div>通过 RWA平台，你可以将你的古董资产代币化或者使用代币来交割古董</div>
          <div>第一步：参与古董拍卖，结束时出价的最后一位是拍到古董的持有者。</div>
          <div>第二步：拍到古董的持有者可以选择现场交割古董或者发射一个新的代币！古董持有者可以去发射台填写新的代币信息。</div>
          <div>第三步： 用户可以去铸造页面，用bucoin铸造新的代币。</div>
        </div>

        <div class="operationGuide_013" @click="operationGuideVisible = false">
          已知晓
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {
  cutAccount,
  lang,
  BigNumber,
  BigNumberStr,
  BigNumberMul,
  BigNumberDiv,
  BigNumberAdd,
  BigNumberSub
} from '../../tools/index';

import transfer from "../../tools/transfer";
import Menu from "../../components/Menu";
import Bottom from "../../components/Bottom";
import * as metaMaskTools from "../../tools/chain";

import md5 from "md5";

import {
  debug,
  uploadHost
} from "@/config";
import { mixin1 } from "@/tools/mixins";
import { setDecimal, toTextDate } from "@/tools/toolUtils";

export default {
  name: "Index",
  components: { Menu, Bottom },
  mixins: [mixin1],
  data() {
    return {
      imgHost: uploadHost,
      projectsType: 'all',
      pageNum: 1,
      limitNum: 10,
      totalNum: 0,
      isProjectsListLoding: false,
      projectsList: [],
      isInitialized: false, // 添加初始化标志
      operationGuideVisible: false
    };
  },
  created() {
    setTimeout(() => {
      this.onAccountsChanged();
    }, 1000);

    transfer.$on("initIndexPageData", () => {
      this.initIndexPageData();
    });

    transfer.$on("indexPageExit", () => {
      this.indexPageExit();
    });
  },
  mounted() {
    if (!this.isInitialized) {
      this.initIndexPageData();
      this.isInitialized = true;
    }
  },
  watch: {
  },
  beforeDestroy() {
  },
  methods: {
    lang(key){
      return lang(key);
    },
    setDecimal(num, numDecimalMax) {
      return setDecimal(num, numDecimalMax, false, false);
    },
    toTextDate(timestamp, isAll) {
      if (isAll) {
        return toTextDate(timestamp).substr(0, 16);
      } else {
        return toTextDate(timestamp).substr(5, 11);
      }
    },
    handleProjectsClick(tab, event) {
      console.log(tab, event);

      this.getProjectsListPage(1);
    },
    async onRefresh(accounts) {
      await this.$store.commit('setState', {
        accounts
      });

      await this.initIndexPageData();
    },
    async initRefreshNetwork() {
      await metaMaskTools.initParams().then(() => {});
    },
    initIndexPageData() {
      if (!this.isInitialized) {
        this.getProjectsListPage(1);
      }
    },
    indexPageExit() {
    },
    toDetails(projectId) {
      this.$router.push({
        path: '/details',
        query: {
          projectId
        }
      });
    },
    toLaunch() {
      transfer.$emit("toMenuPage", 4);
    },
    toKline(token) {
      if (token !== null && token !== undefined && token !== '') {
        this.$router.push({
          path: '/kline',
          query: {
            tokenAddress: token
          }
        });
      } else {
        this.$message.warning('No available K-line data!');
      }
    },
    toMint(id, token) {
      if (id >= 0 && token !== null) {
        this.$router.push({
          path: '/mint',
          query: {
            projectId: id,
            tokenAddress: token
          }
        });
      } else {
        this.$message.warning('Coming soon!');
        return;
      }
    },
    getProjectsListPage(pageNum) {
      try {
        this.isProjectsListLoding = true;

        const page = pageNum > 0 ? this.pageNum = pageNum : this.pageNum = 1 ;
        const limit = this.limitNum;

        // 获取项目列表
        if (this.projectsType === 'all') {
          this.$http.getProjectsList(page, limit).then(res => {

            console.log("getProjectsList: " + JSON.stringify(res));

            if (res.success) {
              this.projectsList = res.data;
              this.totalNum = res.total;

              this.isProjectsListLoding = false;
            } else {
              this.$message.warning('Service Error!');
              this.isProjectsListLoding = false;
            }

          }).catch(err => {
            console.log(err);
            this.isProjectsListLoding = false;
          })
        } else if (this.projectsType === 'active') {
          this.$http.getActiveProjectsAll().then(res => {

            console.log("getActiveProjectsAll: " + JSON.stringify(res));

            if (res.success) {
              this.projectsList = res.data;
              this.totalNum = res.data.length;

              this.isProjectsListLoding = false;
            } else {
              this.$message.warning('Service Error!');
              this.isProjectsListLoding = false;
            }

          }).catch(err => {
            console.log(err);
            this.isProjectsListLoding = false;
          })
        } else if (this.projectsType === 'launched') {
          this.$http.getProjectsLaunchedList(page, limit).then(res => {

            console.log("getProjectsLaunchedList: " + JSON.stringify(res));

            if (res.success) {
              this.projectsList = res.data;
              this.totalNum = res.total;

              this.isProjectsListLoding = false;
            } else {
              this.$message.warning('Service Error!');
              this.isProjectsListLoding = false;
            }

          }).catch(err => {
            console.log(err);
            this.isProjectsListLoding = false;
          })
        } else if (this.projectsType === 'ended') {
          this.$http.getProjectsEndedList(page, limit).then(res => {

            console.log("getProjectsEndedList: " + JSON.stringify(res));

            if (res.success) {
              this.projectsList = res.data;
              this.totalNum = res.total;

              this.isProjectsListLoding = false;
            } else {
              this.$message.warning('Service Error!');
              this.isProjectsListLoding = false;
            }

          }).catch(err => {
            console.log(err);
            this.isProjectsListLoding = false;
          })
        }
      } catch (e) {
        console.log(e);
        this.isProjectsListLoding = false;
      }
    },
    getProjectsStatus(start_time, end_time, status) {
      const timeNum = Date.now() / 1000;

      if (status === 'ended') {
        return 2; // 结束
      } else if (status === 'active' && start_time > timeNum) {
        return 0; // 待开始
      } else if (status === 'active' && start_time <= timeNum && end_time > timeNum) {
        return 1; // 进行中
      } else if (status === 'launched') {
        return 3; // 发射
      } else {
        return 2; // 结束
      }
    }
  }
};
</script>

<style scoped lang="less">
.rwa_index_div {
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  .rwa_index_page_01 {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  .rwa_index_page_02::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  .rwa_index_page_02 {
    overflow-y: auto;
    position: absolute;
    width: 100%;
    top: 84px;
    bottom: 0;
    background: #151515;
    .rwa_index_page_02_01 {
      width: 100%;
      .rwa_index_page_02_011 {
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        align-items: flex-start;
        justify-content: flex-start;
        .rwa_index_page_02_011_bj01 {
          position: absolute;
          top: 0;
          left: 0;
          z-index: 0;
          height: 100%;
          max-height: 880px;
          @media (max-width: 767px){
            max-height: 720px;
          }
        }
        .rwa_index_page_02_011_bj03 {
          position: absolute;
          top: 0;
          right: 0;
          z-index: 0;
          max-width: 60%;
          @media (max-width: 767px){
            max-width: 45%;
            display: none;
          }
        }
        .rwa_index_page_02_0111 {
          width: 80%;
          margin-left: 10%;
          display: flex;
          flex-direction: column;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: flex-start;
          z-index: 1;

          @media (max-width: 767px) {
            width: 90%;
            margin-left: 5%;
          }
          .rwa_index_page_02_0111_01 {
            margin: 80px 0;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: space-evenly;
            align-items: center;
            height: 256px;
            align-self: stretch;
            border-radius: 15px;
            background: #0A0A0A;
            color: white;

            @media (max-width: 767px) {
              margin: 20px 0 35px 0;
              flex-direction: column-reverse;
              justify-content: flex-end;
              height: auto;
              min-height: 535px;
              padding: 20px;
            }
            .index_page_bla_01 {
              .index_page_bla_011 {
                p {
                  color: #FFF;
                  font-family: Inter;
                  font-size: 28px;
                  font-style: normal;
                  font-weight: 700;
                  line-height: 10px; /* 85.714% */

                  @media (max-width: 767px) {
                    line-height: 40px;
                  }
                }
              }
              .index_page_bla_012 {
                color: #3CCD59;
                font-family: Inter;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 24px; /* 171.429% */
                margin: 20px 0;

                @media (max-width: 767px) {
                  font-size: 16px;
                }
              }
              .index_page_bla_013 {
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                justify-content: flex-start;
                align-items: center;
                .index_page_bla_0131 {
                  width: 110px;
                  display: flex;
                  padding: 8px 28px;
                  justify-content: center;
                  align-items: center;
                  gap: 10px;
                  border-radius: 8px;
                  background: #419552;
                  margin-right: 15px;
                  cursor: pointer;
                  @media (max-width: 767px) {
                    height: 43px;
                    zoom: 1.2;
                  }
                }
                .index_page_bla_0132 {
                  width: 90px;
                  display: flex;
                  padding: 8px 28px;
                  justify-content: center;
                  align-items: center;
                  gap: 10px;
                  border-radius: 8px;
                  border: 1px solid #419552;
                  cursor: pointer;
                  @media (max-width: 767px) {
                    height: 43px;
                    zoom: 1.2;
                  }
                }
                .index_page_bla_0133 {
                  width: 110px;
                  margin-left: 15px;
                  font-size: 15px;
                  display: flex;
                  padding: 8px 10px;
                  justify-content: center;
                  align-items: center;
                  gap: 10px;
                  border-radius: 8px;
                  border: 1px solid #419552;
                  cursor: pointer;
                  @media (max-width: 767px) {
                    height: 43px;
                    zoom: 1.2;
                  }
                  img {
                    width: 15px;
                  }
                }
              }
            }
            .index_page_bla_02 {
              img {
                margin-top: 5px;

                @media (max-width: 767px) {
                  width: 100%;
                }
              }
            }
          }
          .rwa_index_page_02_0111_02 {
            width: 100%;
            margin-bottom: 100px;
            .rwa_index_page_02_0111_021 {
              display: flex;
              flex-direction: row;
              flex-wrap: wrap;
              align-content: flex-start;
              justify-content: flex-start;
              align-items: center;

              @media (max-width: 767px) {
                width: 100%;
                flex-direction: column;
                flex-wrap: nowrap;
                justify-content: flex-start;
                align-items: center;
              }
              .antique_info_div {
                @media (max-width: 767px) {
                  zoom: 1.25;
                  width: 100%;
                  height: auto;
                }
                position: relative;
                display: flex;
                width: 240px;
                height: 345px;
                flex-direction: column;
                align-items: flex-end;
                border-radius: 16px;
                border: 1px solid rgba(153, 153, 153, 0.30);
                background: #313131;
                margin: 10px 10px 10px 10px;

                .antique_info_div01 {
                  position: absolute;
                  top: 0;
                  left: 0;
                  cursor: pointer;

                  @media (max-width: 767px) {
                    position: relative; // 改为相对定位
                    width: 100%;  // 添加宽度100%
                    height: auto; // 让高度自适应
                  }
                  img {
                    position: absolute;
                    top: 0;
                    left: 1px;
                    width: 238px;
                    height: 179px;
                    object-fit: cover;
                    border-top-left-radius: 16px;
                    border-top-right-radius: 16px;

                    @media (max-width: 767px) {
                      position: relative; // 改为相对定位
                      width: 100%;
                      height: auto; // 保持图片比例
                      min-height: 270px;
                    }
                  }
                  div {
                    position: absolute;
                    top: 140px;
                    left: 0.3px;
                    display: flex;
                    width: 239px;
                    padding: 8px 0;
                    justify-content: center;
                    align-items: center;
                    gap: 4px;
                    //background: rgba(32, 178, 108, 0.80);
                    background: #1ACF7880;
                    color: #FFF;
                    font-family: Roboto;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 700;
                    line-height: normal;

                    @media (max-width: 767px) {
                      top: auto;
                      bottom: 0; // 改为底部定位
                      width: 100%;
                      height: 38px;
                      font-size: 14px;
                    }
                  }
                }
                .antique_info_div02 {
                  position: absolute;
                  top: 185px;
                  left: 10px;
                  width: 218px;
                  height: 34px;
                  color: #FFF;
                  font-family: Roboto;
                  font-size: 18px;
                  font-style: normal;
                  font-weight: 700;
                  line-height: normal;
                  border-bottom: 1px solid #666666;

                  @media (max-width: 767px) {
                    position: static;
                    top: 260px;
                    width: calc(100% - 20px);
                    height: 42px;
                    line-height: 40px;
                    margin-right: 10px;
                  }
                }
                .antique_info_div03 {
                  position: absolute;
                  top: 220px;
                  left: 0;
                  width: 100%;

                  @media (max-width: 767px) {
                    position: static;
                    top: 300px;
                  }
                  .antique_info_div031 {
                    height: 65px;
                    width: 100%;
                    margin-top: 12px;
                    .antique_info_div0311 {
                      display: flex;
                      flex-direction: row;
                      flex-wrap: nowrap;
                      justify-content: flex-start;
                      align-items: center;
                      margin: 10px 0 0 10px;
                      span {
                        color: #999;
                        font-family: Inter;
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: normal;
                        width: 80px;

                        @media (max-width: 767px) {
                          font-family: auto;
                        }
                      }
                      div {
                        color: #FFF;
                        font-family: Inter;
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: normal;

                        @media (max-width: 767px) {
                          font-family: auto;
                        }
                      }
                    }
                    .antique_info_div0312 {
                      display: flex;
                      flex-direction: row;
                      flex-wrap: nowrap;
                      justify-content: flex-start;
                      align-items: center;
                      margin: 10px 0 0 10px;
                      span {
                        color: #999;
                        font-family: Inter;
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: normal;
                        width: 80px;

                        @media (max-width: 767px) {
                          font-family: auto;
                        }
                      }
                      div {
                        color: #FFF;
                        font-family: Inter;
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: normal;

                        @media (max-width: 767px) {
                          font-family: auto;
                        }
                      }
                    }
                  }
                  .antique_info_div032 {
                    position: absolute;
                    right: 0;
                    bottom: 12px;
                    display: flex;
                    padding: 8px 15px;
                    justify-content: center;
                    align-items: center;
                    gap: 4px;
                    border-radius: 100px 0 0 100px;
                    background: #20B26C;
                    color: #FFF;
                    font-family: Roboto;
                    font-size: 15px;
                    font-style: normal;
                    font-weight: 700;
                    line-height: normal;

                    @media (max-width: 767px) {
                      font-size: 14px;
                    }
                  }
                  .antique_info_div032_end {
                    background: #C69C6D !important;
                  }
                }
                .antique_info_div04 {
                  position: absolute;
                  top: 295px;
                  left: 0;
                  width: 100%;
                  color: #FFFFFF;
                  font-weight: 600;
                  @media (max-width: 767px) {
                    position: static;
                    margin-bottom: 12px;
                  }
                  .antique_info_div041 {
                    width: 218px;
                    margin-left: 10px;
                    display: flex;
                    padding: 8px 28px;
                    justify-content: center;
                    align-items: center;
                    gap: 10px;
                    align-self: stretch;
                    border-radius: 8px;
                    background: #1F4C28;
                    color: #64986F;
                    cursor: pointer;
                    @media (max-width: 767px) {
                      width: calc(100% - 20px);
                      margin-right: 10px;
                    }
                  }
                  .antique_info_div042 {
                    width: 218px;
                    margin-left: 10px;
                    display: flex;
                    padding: 8px 28px;
                    justify-content: center;
                    align-items: center;
                    gap: 10px;
                    align-self: stretch;
                    border-radius: 8px;
                    background: #419552;
                    cursor: pointer;
                    @media (max-width: 767px) {
                      width: calc(100% - 20px);
                      margin-right: 10px;
                    }
                  }
                  .antique_info_div043 {
                    width: 218px;
                    margin-left: 10px;
                    display: flex;
                    padding: 8px 28px;
                    justify-content: center;
                    align-items: center;
                    gap: 10px;
                    align-self: stretch;
                    border-radius: 8px;
                    background: #419552;
                    cursor: pointer;
                    @media (max-width: 767px) {
                      width: calc(100% - 20px);
                      margin-right: 10px;
                    }
                  }
                  .antique_info_div040s {
                    width: 218px;
                    margin-left: 10px;
                    display: flex;
                    flex-direction: row;
                    flex-wrap: nowrap;
                    justify-content: flex-start;
                    align-items: center;
                    @media (max-width: 767px) {
                      width: calc(100% - 20px);
                      margin-right: 10px;
                    }

                    .antique_info_div040s1 {
                      width: 35px;
                      cursor: pointer;
                    }
                    .antique_info_div040s2 {
                      width: 173px;
                      margin-left: 10px;
                      display: flex;
                      padding: 8px 28px;
                      justify-content: center;
                      align-items: center;
                      gap: 10px;
                      align-self: stretch;
                      border-radius: 8px;
                      background: #419552;
                      cursor: pointer;
                      @media (max-width: 767px) {
                        width: calc(100% - 45px);
                        margin-right: 10px;
                      }
                    }
                  }
                }
              }
            }
            .rwa_index_page_02_0111_021_null {
              color: white;
              font-size: 26px;
              font-style: italic;
              font-weight: 900;
              text-align: center;
              margin-top: 30px;
              margin-bottom: 80px;
            }
            .rwa_index_page_02_0111_022 {
              margin-top: 35px;
              @media (max-width: 767px) {
                zoom: 1.45;
              }
            }
          }
          .rwa_index_page_02_0111_03 {
            .rwa_index_page_02_0111_031 {
              color: #FFF;
              text-align: center;
              font-family: Inter;
              font-size: 24px;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
            }
            .rwa_index_page_02_0111_032 {
              text-align: center;
              display: flex;
              flex-direction: row;
              justify-content: center;

              @media (max-width: 767px) {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                align-items: center;
                justify-content: space-around;
                align-content: flex-start;
                margin: 30px 0;
              }
              img {
                width: 60%;
                min-width: 680px;
                margin: 30px 0;

                @media (max-width: 767px) {
                  width: 30%;
                  min-width: 135px;
                  margin: 10px 0;
                }
              }
            }
          }
        }
      }
    }
    .rwa_index_page_03 {
      width: 100%;
    }
  }

  .operationGuide_01 {
    width: 780px;
    @media (max-width: 767px) {
      width: 430px;
    }
    .operationGuide_011 {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: space-between;
      align-items: center;
      .operationGuide_0111 {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: flex-start;
        color: #FFF;
        font-family: "Microsoft YaHei";
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: 32px; /* 133.333% */
        img {
          width: 24px;
          margin-right: 5px;
        }
      }
      .operationGuide_0112 {
        width: 25px;
        cursor: pointer;
      }
    }

    .operationGuide_012 {
      margin: 30px 0;
      div {
        color: #FFF;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px; /* 171.429% */
        align-self: stretch;
        @media (max-width: 767px) {
          font-size: 18px;
          line-height: 28px; /* 171.429% */
        }
      }
    }

    .operationGuide_013 {
      display: flex;
      height: 50px;
      padding: 0 20px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      flex: 1 0 0;
      border-radius: 12px;
      background: #20B26C;
      color: #FFFFFF;
      cursor: pointer;
      @media (max-width: 767px) {
        font-size: 20px;
      }
    }
  }
}
</style>

<style>
.rwa_index_div {
  .el-pagination {
    text-align: center;
  }
  .el-pagination.is-background .el-pager li {
    background-color: #313131;
    color: #999999;
    border-radius: 5px !important;
  }
  .el-pagination.is-background .el-pager li:hover {
    color: #20B26C !important;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #313131;
    border: 1.5px solid #20B26C;
    color: #20B26C;
  }
  .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
    background-color: #313131;
    color: #999999;
    border-radius: 5px !important;
  }

  .el-form {
    margin: 0 20px !important;
  }

  .el-form-item__label {
    color: white !important;
  }

  .el-form-item__label:before {
    color: #6cf585 !important;
  }

  .el-textarea__inner {
    color: #c8cbd2 !important;
    background-color: transparent !important;
    border: 1px solid #61823a !important;
  }

  .el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path {
    color: #1CFE5E !important;
  }

  .el-radio__input.is-checked .el-radio__inner {
    border-color: #1CFE5E !important;
    background: #1CFE5E !important;
  }

  .el-radio__input.is-checked+.el-radio__label {
    color: #1CFE5E !important;
  }

  .el-radio {
    color: #f6f6f6 !important;
  }

  .el-dialog {
    @media (max-width: 767px) {
      width: 500px;
    }
  }

  .el-dialog__header {
    padding: 0 !important;
  }

  .el-dialog__body {
    width: 839px;
    @media (max-width: 767px) {
      width: 500px;
    }
  }

  .el-cascader__dropdown {
    top: 35px !important;
  }

  /* 响应式文本颜色 */
  .responsive-text {
    color: #20944B;
  }

  .el-badge__content.is-fixed {
    right: 25px;
  }
  .el-badge__content {
    background-color: #f22121;
  }

  @media (max-width: 1023px) {
    .responsive-text {
      color: #FFFFFF;
    }
  }

  .el-tabs--top {
    margin-top: -20px;
    margin-bottom: 20px;

    @media (max-width: 767px) {
      margin-top: 0;
    }
  }
  .el-tabs__nav {
    @media (max-width: 767px) {
      width: 100% !important;
    }
  }
  .el-tabs__item {
    width: 100px !important;
    text-align: center;
    font-size: 17px;
    color: #FFFFFF !important;
    padding: 0 !important;

    @media (max-width: 767px) {
      width: 25% !important;
    }
  }
  .el-tabs__item.is-active {
    color: #20944B !important;
  }
  .el-tabs__active-bar {
    width: 100px !important;

    @media (max-width: 767px) {
      width: 25% !important;
    }
  }
}
</style>
